module.exports = __webpack_public_path__ + "static/media/halmstadvapen.ee39145b.png";